import drawText from './drawText'
import drawRect from './drawRect'
import drawFontIcon from './drawFontIcon'
import { MAPPING } from './utils'
import inView from './inView'
import getSpaceRadius from './getSpaceRadius'

const drawPin = ({ x, y, r, context, selected, fill, transparent }) => {
  r *= 1.3
  !transparent &&
    drawRect({
      x: x - r,
      y: y - r,
      w: r * 2,
      h: r * 2,
      fillStyle: fill,
      context,
    })

  if (selected) {
    drawRect({
      x: x - 1.2 * r,
      y: y - 1.2 * r,
      w: r * 2.4,
      h: r * 2.4,
      strokeStyle: '#1B4BC5',
      lineWidth: Math.min(r / 2.2, 4),
      context,
    })
  }
}

const drawPinIcon = ({ x, y, r, context, iconClass, fillStyle, fontFamily }) => {
  drawFontIcon({
    x,
    y,
    fillStyle,
    fontSize: 1.7 * r,
    text: MAPPING[iconClass],
    context,
    fontFamily,
  })
}

const Pin = ({
  image,
  pin,
  dx,
  dy,
  maxScale,
  xScale,
  yScale,
  rScale,
  context,
  transform: t,
  screen,
  filtered,
  selected,
  fontConfig,
  preview,
  draggedItem,
}) => {
  const isFa = pin.globalMapObject.fontFamily === 'FontAwesome'
  const x = dx * t.k + xScale(pin.map.x)
  const y = dy * t.k + yScale(pin.map.y)
  const r = getSpaceRadius({
    space: { w: pin.map.w },
    k: t.k,
    rScale,
    filtered,
    maxScale,
  })

  if (t.k >= 3 && !inView({ x, y, screen })) {
    return
  }

  context.globalAlpha = 1

  if (filtered || preview || draggedItem) {
    context.globalAlpha = 0.5
  }

  if (pin.globalMapObject.name === 'Text') {
    return drawText({
      context,
      x,
      y,
      fontSize: fontConfig.label,
      fillStyle: '#333',
      text: pin.map.name,
      center: true,
      selected,
    })
  }

  drawPin({
    context,
    x,
    y,
    r,
    selected,
    fill: pin.globalMapObject.color,
    transparent: pin.globalMapObject.limitOnePerFloor,
  })

  let size = 2 * r

  image && context.drawImage(image, x - size / 2, y - size / 2, size, size)

  drawPinIcon({
    context,
    x,
    y,
    r: 0.8 * r,
    fontFamily: isFa ? "'Font Awesome 6 Pro'" : 'effective-font',
    iconClass: isFa ? pin.globalMapObject.icon : `fe-${pin.globalMapObject.icon}`,
    fillStyle: pin.globalMapObject.limitOnePerFloor ? pin.globalMapObject.color : '#fff',
  })

  context.globalAlpha = 1
}

export default Pin
